import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// UTILS
import { treatObjNullValues } from 'utils/genericFunctions';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	IRequestPesquisaObservacao,
	consultaPesquisaObservacaoSuccess,
	consultaPesquisaObservacaoFailure,
	consultaPesquisaObservacaoClear,
} from './actions';

function* consultaPesquisaObservacaoRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: IRequestPesquisaObservacao } = request;
	const { usuario, senha, numeroRg } = payload;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		`${numeroRg}/observacoes`,
		undefined,
		undefined,
		undefined,
		undefined,
		{
			usuario,
			senha,
		},
		undefined,
	);

	if (response.status === 200) {
		// Tratativa para tratar valores NULL.
		response.data = treatObjNullValues(response.data);

		yield put(consultaPesquisaObservacaoClear());
		yield put(consultaPesquisaObservacaoSuccess(response.data));
	} else if (response.error) {
		yield put(consultaPesquisaObservacaoFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PESQUISA_OBSERVACAO_REQUEST,
		consultaPesquisaObservacaoRequest,
	),
]);
